import { Select, SelectProps, alpha, useTheme } from '@mui/material'

export const StyledSelect = (props: SelectProps) => {
  const { palette } = useTheme()

  return (
    <Select
      {...props}
      sx={{
        color: 'secondary.main',
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'secondary.main',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'secondary.main',
        },
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: alpha(palette.secondary.main, 0.5),
        },
        '.MuiSelect-iconOutlined': {
          color: 'inherit',
        },
        ...props.sx,
      }}
    />
  )
}
